import React, { Component } from 'react'
import { connect } from '@cerebral/react'
import { state, signal } from 'cerebral/tags'
import { t } from '@billes/translator-client'
import { NavigateDown } from 'components/Icons'
import { Dropdown } from '@billes/components'

const sortTypes = {
  LATEST: {
    label: 'bms.media.sort.latestAsc',
    sortType: 'LATEST'
  },
  LATEST_REVERSE: {
    label: 'bms.media.sort.latestDesc',
    sortType: 'LATEST_REVERSE'
  },
  A_Z: {
    label: 'bms.media.sort.alphabeticalAsc',
    sortType: 'A_Z'
  },
  Z_A: {
    label: 'bms.media.sort.alphabeticalDesc',
    sortType: 'Z_A'
  }
}

export default connect(
  {
    sortType: state`media.sortType`,
    changeSortType: signal`media.changeSortType`
  },
  class Sort extends Component {
    render() {
      const { sortType, changeSortType } = this.props

      return (
        <div
          tabIndex={1}
          style={{
            background: '#efefef',
            paddingLeft: 2,
            paddingRight: 2
          }}
        >
          <Dropdown
            flip
            style={{ background: '#efefef', height: 18, padding: 0 }}
            icon={<NavigateDown viewBox={'4 1 22 22'} />}
            label={t('bms.media.sort', { type: t(sortTypes[sortType].label) })}
            items={Object.keys(sortTypes).map(key => {
              const item = { ...sortTypes[key], label: t(sortTypes[key].label) }
              return {
                ...item,
                action: () => {
                  changeSortType({ sortType: key })
                }
              }
            })}
          />
        </div>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/Media/Strip/sort.js